import { addressApiQuery } from "./rmo-query";

export const triggerAddressApi = (country, addressInput) => {
  const headersAddressApi = new Headers();
  // const countryUpperCase = country?.toUpperCase();
  headersAddressApi.append("x-wu-operationname", "addressLookup");
  headersAddressApi.append("Content-Type", "application/json");
  headersAddressApi.append("x-wu-accesscode", "RtYV3XDz9EA");
  const akCountry = getAkCountryRMO()
  const countryUpperCase = (country || akCountry).toUpperCase();
  headersAddressApi.append("WUCountryCode", countryUpperCase);

  let addressRequest = {
    address: addressInput.value,
    countryCode: countryUpperCase,
  };

  const graphql = JSON.stringify({
    query: addressApiQuery,
    variables: {
      req: addressRequest,
    },
  });
  const requestOptions = {
    method: "POST",
    headers: headersAddressApi,
    body: graphql,
    redirect: "follow",
  };

  return fetchApiWu(routerUrl, requestOptions, "addressApiVulcan", false)
    .then((result) => {
      return Promise.resolve({
        address: result?.data?.addressLookup?.results,
      });
    })
    .catch((error) => console.log("Address not found: ", error));
};
